import React from 'react';
import PageMeta from 'src/components/organisms/page-meta';
import { useUniverseConfigurations } from 'src/features/common/universe/hooks/use-universe-configurations';
import { LandingPageLayout } from 'src/features/white-labels/nftsuperlab/landing/universe-landing.styles';
import { Discord } from 'src/features/white-labels/nftsuperlab/universe/components/discord';
import { useCollectTemplateComponents } from 'src/features/white-labels/nftsuperlab/universe/hooks/use-collect-template-components';
import { Spacing } from 'src/ui/common/atoms/spacing';

const UniverseLanding = () => {
    const configurations = useUniverseConfigurations();

    const pageComponents = useCollectTemplateComponents({
        configurations,
    });

    return (
        <>
            <PageMeta title="Homepage" />
            <LandingPageLayout>
                {pageComponents}
                <Discord />
            </LandingPageLayout>
            <Spacing mt="80px" mtMd="140px" />
        </>
    );
};

export default UniverseLanding;
